<div class="animated fadeIn">
  @if (_currentWidgets.top) {
    <div class="row sc-main top-section" id="section-top" [ngClass]="(appService._dashBoardOpened)?'cards-shown':'cards-hidden'">
      <!-- <div class="col-12 text-center mb-3"> -->
      <!-- <i id="dash-card-toggle-icon" [ngClass]="(appService._dashBoardOpened)?'':'kx-rotate'"  aria-hidden="true" class="fa fa-chevron-circle-up dash-card-toggle-icon" (click)="appService._dashBoardOpened = !appService._dashBoardOpened"></i> -->
      <span class="toggle-icon-container">
        <i id="dash-card-toggle-icon" [ngClass]="(appService._dashBoardOpened)?'':'kx-rotate'" aria-hidden="true" class="fa fa-chevron-circle-up dash-card-toggle-icon" (click)="appService._dashBoardOpened = !appService._dashBoardOpened"></i>
      </span>
    <!-- </div> -->
    <div class="col-12 pl-0 pr-0">
      <div class="scroll-indicator-right" (click)="triggerDCScrollRight($event)">
        <i class="fa fa-chevron-circle-right scroll-card-icon" aria-hidden="true"></i>
      </div>
      <div class="scroll-indicator-left" (click)="triggerDCScrollLeft($event)">
        <i class="fa fa-chevron-circle-left scroll-card-icon" aria-hidden="true"></i>
      </div>
      <div class="kx-scroll-div kx-scroll-main">
        @if (_viewInit) {
          <div id="isScrollable" class="isscrollable">
            @for (sectionKey of _topKeys; track sectionKey) {
              <app-widget [widget]="_currentWidgets.top[sectionKey]" [selection]="topWidSelection"></app-widget>
            }
          </div>
        }
        <ng-template #topWidgetSelection>
        </ng-template>
      </div>
    </div>
  </div>
}
@if (_currentWidgets.bottom) {
  <div class="row" id="section-bottom">
    @if (_viewInit) {
      <div>
        @for (sectionKey of _bottomKeys; track sectionKey) {
          <app-widget class="col-md-6" [widget]="_currentWidgets.bottom[sectionKey]" [selection]="bottomWidSelection"></app-widget>
        }
      </div>
    }
    <ng-template #bottomWidgetSelection>
    </ng-template>
  </div>
}
</div>
<div dhs-modal></div>